import { render, staticRenderFns } from "./AssetsDialogComponent.vue?vue&type=template&id=5df76285&scoped=true&"
import script from "./AssetsDialogComponent.vue?vue&type=script&lang=js&"
export * from "./AssetsDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssetsDialogComponent.vue?vue&type=style&index=0&id=5df76285&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df76285",
  null
  
)

export default component.exports